import { ArrowRight, ShieldCheck } from "@phosphor-icons/react";
import { STATS } from "@/data/content";

export const Hero = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" data-testid="hero-section" className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 animate-fade-up">
          <div className="inline-flex items-center gap-2 border border-slate-300 px-4 py-1.5 mb-8">
            <ShieldCheck weight="fill" className="h-4 w-4 text-[#B91C1C]" />
            <span className="overline text-slate-600">Your Trusted Collection &amp; Recovery Partner</span>
          </div>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
            Ethical debt recovery for India&apos;s lenders.
          </h1>
          <p className="mt-7 text-lg text-slate-600 leading-relaxed max-w-xl">
            Crestline Risk Management is a professional collection and recovery organisation serving banks,
            NBFCs, fintechs, telecom and financial institutions — improving recovery rates while protecting
            customer relationships.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => go("#contact")}
              className="group inline-flex items-center justify-center gap-2 px-7 py-4 bg-slate-900 text-white font-semibold hover:bg-[#B91C1C] transition-colors duration-200"
            >
              Partner With Us
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => go("#services")}
              className="inline-flex items-center justify-center px-7 py-4 border border-slate-900 text-slate-900 font-semibold hover:bg-slate-900 hover:text-white transition-colors duration-200"
            >
              Explore Services
            </button>
          </div>
        </div>

        <div className="lg:col-span-6 animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab"
              alt="Corporate financial district skyline"
              className="w-full h-[380px] lg:h-[520px] object-cover grayscale-[15%]"
              loading="eager"
            />
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-20 lg:mt-28">
        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-slate-200">
          {STATS.map((s) => (
            <div key={s.label} data-testid={`stat-${s.label}`} className="border-r border-b border-slate-200 p-8">
              <p className="font-serif-display text-3xl lg:text-4xl font-bold text-slate-900">{s.value}</p>
              <p className="mt-2 text-sm text-slate-500">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
